import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Querier from 'querier';

/*
 * A shared paginator component for incidents and uptime history.
 *
 * @param {func} responseHandler = callback function for the pagination action
 * @param {string} startDate = label for the paginator start date
 * @param {string} endDate = label for the paginator end date
 */
class HistoryPaginator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: parseInt(Querier.get().page || 1, 10),
    };
    this._pageForward = this._pageForward.bind(this);
    this._pageBack = this._pageBack.bind(this);
    this._responseHandler = props.responseHandler;
  }

  _canPageBack() {
    return this.state.pageNumber < 40;
  }

  _canPageForward() {
    return this.state.pageNumber > 1;
  }

  _pageBack(event) {
    event.preventDefault();
    if (this._canPageBack()) {
      this.state.pageNumber += 1;
      Querier.fetch({ page: this.state.pageNumber }, { merge: true }).then(
        (responseData) => {
          this._responseHandler(responseData);
        },
      );
    }
  }

  _pageForward(event) {
    event.preventDefault();
    if (this._canPageForward()) {
      this.state.pageNumber -= 1;
      Querier.fetch({ page: this.state.pageNumber }, { merge: true }).then(
        (responseData) => {
          this._responseHandler(responseData);
        },
      );
    }
  }

  _renderControl({ href, className, onClick, label, enabled, arrow }) {
    if (this.props.a11yRolesErb) {
      return (
        <button
          className={className}
          onClick={onClick}
          aria-label={label}
          disabled={!enabled}
        >
          <i className={arrow} />
        </button>
      );
    }
    return (
      <a
        href={href}
        className={className}
        onClick={onClick}
        aria-label={label}
        aria-disabled={!enabled}
        tabIndex={enabled ? undefined : -1}
      >
        <i className={arrow} />
      </a>
    );
  }

  render() {
    const backClass = cx('previous-page border-color color-secondary', {
      disabled: !this._canPageBack(),
    });
    const fwdClass = cx('next-page border-color color-secondary', {
      disabled: !this._canPageForward(),
    });

    return (
      <div className="pagination-container">
        <div className="pagination">
          {this._renderControl({
            href: '#back',
            className: backClass,
            onClick: this._pageBack,
            label: 'Previous page',
            enabled: this._canPageBack(),
            arrow: 'left-arrow',
          })}
          <span className="current">
            <span>{this.props.startDateMonth}</span>
            <var data-var="start-date-year">
              {' '}
              {this.props.startDateYear}
            </var> to <span>{this.props.endDateMonth}</span>
            <var data-var="end-date-year"> {this.props.endDateYear}</var>
          </span>
          {this._renderControl({
            href: '#forward',
            className: fwdClass,
            onClick: this._pageForward,
            label: 'Next page',
            enabled: this._canPageForward(),
            arrow: 'right-arrow',
          })}
        </div>
      </div>
    );
  }
}

HistoryPaginator.propTypes = {
  startDateMonth: PropTypes.string.isRequired,
  startDateYear: PropTypes.number.isRequired,
  endDateMonth: PropTypes.string.isRequired,
  endDateYear: PropTypes.number.isRequired,
  responseHandler: PropTypes.func.isRequired,
  a11yRolesErb: PropTypes.bool,
};

export default HistoryPaginator;
